import $ from 'jquery'

import BoxReservationPanel from './components/box-reservation-panel'

if ($('#box .reservation-panel').length) {
  new BoxReservationPanel()
}



// WEBPACK FOOTER //
// ./box/static/box/js/apps.js